export const EMPTY_PROFILE = `{
  
}`;

export const ROOT_FOLDER = "/";
